import React from "react";
import PropTypes from "prop-types";

function EstablishmentCards(props) {
    const { cards } = props;

    if (!cards.cards || !cards.cards.length) {
        return false;
    }

    return (
        <section className="layer">
            <div className="site-width sign--palm">
                <div className="layout layout--gutter layout--equalheight layout--center sign-inv">
                    {cards.cards.map((card, index) => (
                        <div className="layout__cell layout__cell--fit unit-3-12--desk unit-6-12--lap unit-1-1 sign">
                            <a className="card" href={card.link} key={index}>
                                <div className="card__visual">
                                    <figure className="visual ratio--4x3">
                                        <img
                                            className="image"
                                            alt={card.imageTitle}
                                            src={card.imageUrl}
                                        />
                                    </figure>
                                </div>
                                <div className="card__body">
                                    <div className="card__main">
                                        <h2 className="card__heading">
                                            <span className="card__title">
                                                {card.title}
                                            </span>
                                            <span className="card__subtitle">
                                                {card.subtitle}
                                            </span>
                                        </h2>
                                        <div className="card__content">
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: card.content,
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="card__actions">
                                        <button
                                            aria-label={card.label}
                                            type="button"
                                            className="button-arrow"
                                        />
                                    </div>
                                </div>
                            </a>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

EstablishmentCards.propTypes = {
    cards: PropTypes.object,
};

EstablishmentCards.defaultProps = {
    cards: {},
};

export default EstablishmentCards;
